import React, { useState,useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../Components/ErrorMessage";
import { replacePlaceholder } from "../../Utils/Utils";

const NumericQuestion = ({ question, handleChange, formValues, showError }) => {
  const { tempId, questionDescription, inputType, minValue, maxValue, isMandatory, requiredErrorText, placeHolderText } = question;
  const [isAnswerValidNumeric, setIsAnswerValidNumeric] = useState(true);
  const questionText = replacePlaceholder(question.questionText, formValues);

  // Get current value from formValues
  const currentValue = formValues[tempId] || "";
  const hasAnswer = currentValue !== "";

  const handleNumericChange = (event) => {
    const value = event.target.value;
    
    // Check if empty string (when field is cleared)
    if (value === "") {
      setIsAnswerValidNumeric(true);
      handleChange(event);
      return;
    }

    // Convert to number for validation
    const numericValue = Number(value);
    
    if (isNaN(numericValue) || numericValue < minValue || numericValue > maxValue) {
      setIsAnswerValidNumeric(false);
      // Still allow the change to be made (user might be in the middle of typing)
      handleChange(event);
      return;
    }

    setIsAnswerValidNumeric(true);
    handleChange(event);
  };

  // Validate the current value when the component mounts or when the question changes
  useEffect(() => {
    if (currentValue === "") return;
    
    const numericValue = Number(currentValue);
    setIsAnswerValidNumeric(
      !isNaN(numericValue) && 
      numericValue >= minValue && 
      numericValue <= maxValue
    );
  }, [currentValue, minValue, maxValue]);

  return (
    <Card className={`mt-3 ${isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form.Group>
          <div className="d-flex flex-column">
            <Form.Label>
              <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                {tempId}.{questionText}
                {isMandatory && <span className="text-danger">*</span>}
              </b>
            </Form.Label>
            <Form.Label>
              <b style={{ color: 'lightblue' }}>{questionDescription}</b>
            </Form.Label>
            {isMandatory && showError && !hasAnswer && (
              <ErrorComponent message={requiredErrorText} />
            )}
            {!isAnswerValidNumeric && (
              <ErrorComponent message={`Value must be between ${minValue} and ${maxValue}`} />
            )}
          </div>
          <Form.Control
            type="number"
            name={tempId}
            value={currentValue}
            required={isMandatory}
            min={minValue}
            max={maxValue}
            onChange={handleNumericChange}
            placeholder={placeHolderText}
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default NumericQuestion;
